export const WEBSITE_URL = 'https://timeitis.net';
export const TWITTER_SHARE_URL = `https://twitter.com/intent/tweet?text=Qu%27elle+heure+est+il+%3f%20${WEBSITE_URL}+`;
export const FACEBOOK_SHARE_URL = `https://www.facebook.com/sharer/sharer.php?u=${WEBSITE_URL}`;
